import { z } from 'zod';
// Signed facility-contract PDF — the executed commercial agreement.
// Operator-only upload (presigned PUT); the facility gets a read-only download.
// Endpoint mapping:
//   POST /api/v1/admin/facilities/:id/contract/doc-upload-url  — presigned PUT URL
//   PUT  /api/v1/admin/facilities/:id/contract/doc             — attach to current contract
//   GET  /api/v1/admin/facilities/:id/contract/doc             — operator download
//   GET  /api/v1/me/facility/profile/contract-doc              — facility download
/** PDF only; 20 MB ceiling. */
export const FACILITY_CONTRACT_DOC_MAX_BYTES = 20 * 1024 * 1024;
export const FACILITY_CONTRACT_DOC_CONTENT_TYPE = 'application/pdf';
/** Body for `POST /admin/facilities/:id/contract/doc-upload-url` — asks for a
 *  short-TTL signed PUT URL. Content type is fixed to PDF. */
export const FacilityContractDocUploadUrlRequestSchema = z.object({
    contentType: z.literal(FACILITY_CONTRACT_DOC_CONTENT_TYPE),
    contentLength: z.number().int().positive().max(FACILITY_CONTRACT_DOC_MAX_BYTES),
});
export const FacilityContractDocUploadUrlResponseSchema = z.object({
    uploadUrl: z.string().url(),
    objectStorageKey: z.string(),
    expiresAt: z.string().datetime(),
});
/** Body for `PUT /admin/facilities/:id/contract/doc` — attaches an
 *  already-uploaded object to the CURRENT contract (no new version). */
export const FacilityContractDocAttachRequestSchema = z.object({
    objectStorageKey: z.string().max(500),
});
/** Signed download URL for the current contract's PDF. Shared by the operator
 *  (`GET /admin/facilities/:id/contract/doc`) and — for their own facility —
 *  the facility user (`GET /me/facility/profile/contract-doc`). */
export const FacilityContractDocDownloadResponseSchema = z.object({
    downloadUrl: z.string().url(),
});
//# sourceMappingURL=contract-doc.schema.js.map